import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releasesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusOff: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	turnOnButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	turnOffButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.manage-features.card-title',
		defaultMessage: 'Manage plan features',
		description: 'Title for the manage plan features action card',
	},
	releasesLabel: {
		id: 'conversation-assistant-message-actions.manage-features.releases-label',
		defaultMessage: 'Releases',
		description:
			'Text shown as a label for the Releases feature toggle row in the manage plan features action card within Rovo chat.',
	},
	statusOn: {
		id: 'conversation-assistant-message-actions.manage-features.status-on',
		defaultMessage: 'On',
		description: 'Status label when a feature is being turned on',
	},
	statusOff: {
		id: 'conversation-assistant-message-actions.manage-features.status-off',
		defaultMessage: 'Off',
		description: 'Status label when a feature is being turned off',
	},
	turnOnButton: {
		id: 'conversation-assistant-message-actions.manage-features.turn-on-button',
		defaultMessage: 'Turn on',
		description:
			'Text shown on a button in the manage plan features action card in Rovo chat that enables the selected feature (e.g. Releases).',
	},
	turnOffButton: {
		id: 'conversation-assistant-message-actions.manage-features.turn-off-button',
		defaultMessage: 'Turn off',
		description:
			'Text shown on a button in the manage plan features action card in Rovo chat that disables the selected feature (e.g. Releases).',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.manage-features.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text shown on a button in the manage plan features action card in Rovo chat that discards any pending changes and closes the card.',
	},
});

export default messages;
